import PropTypes from 'prop-types';
import * as React from 'react';

import styles from './ScreenBanner.less';

const ScreenBanner = ({backgroundColor, hasStripes, stripedColor}) => {
  const dynamicStyles = {
    ...(hasStripes
      ? {
          background: `repeating-linear-gradient(-55deg, ${backgroundColor}, ${backgroundColor} 10px, ${stripedColor} 10px, ${stripedColor} 20px)`,
        }
      : {backgroundColor}),
    borderColor: backgroundColor,
  };
  return <div className={styles.dlScreenBanner} style={dynamicStyles} />;
};

ScreenBanner.displayName = 'ScreenBanner';

ScreenBanner.propTypes = {
  backgroundColor: PropTypes.string,
  hasStripes: PropTypes.bool,
  stripedColor: PropTypes.string,
};

ScreenBanner.defaultProps = {
  backgroundColor: '#ffffff',
  hasStripes: false,
  stripedColor: '#ffffff',
};

export default ScreenBanner;
